import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';
import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)(({ theme }) => ({
  '& .ant-modal-content': {
    padding: '30rem',
  },

  '& .ant-modal-footer': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '10rem',
    marginBlockStart: '25rem',

    '& button': {
      fontSize: theme.typography.size20,
    },
  },
}));

export const Divider = styled.div(({ theme }) => ({
  width: '100%',
  height: '0.5px',
  background: theme.palette.erieBlack,
  marginBlock: '25rem',
}));

export const ModalButton = styled(CommonButton)(({ theme }) => ({
  width: '91rem',

  '&[data-type="submit"]': {
    backgroundColor: theme.palette.artichoke,
    color: theme.palette.white,
    borderColor: 'transparent',
  },
}));

export const Content = styled.div(() => ({
  minWidth: '550rem',
  minHeight: '500rem',
}));

export const ProductItem = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10rem',
  marginBlock: '20rem',
}));

export const ProductImage = styled.img(() => ({
  blockSize: '42rem',
  inlineSize: '60rem',
}));

export const ProductName = styled.span(() => ({}));
